// Settings Routes
export const SETTINGS = '/settings'
export const SETTINGS_PRIMARY_CONTACT = '/settings/primary-contact'
export const SETTINGS_ACCOUNTS = '/settings/accounts'
export const SETTINGS_GENERAL = '/settings/general'
export const SETTINGS_BRAND = '/settings/brand'
export const SETTINGS_STORE = '/settings/stores'
export const SETTINGS_STORE_DETAIL = '/settings/stores/:store_uuid'
export const SETTINGS_SHIPPING_INSURANCE = '/settings/shipping-insurance'
export const RETAILER_CLAIMS = '/claims'
export const RETAILER_CLAIMS_CREATE = '/claims/create'
export const RETAILER_CLAIMS_DETAIL = '/claims/:id'
export const CUSTOMER_PERSONAL_SETTINGS = '/personal-details'

// Onboarding Routes
export const ONBOARDING_WELCOME = '/onboarding/welcome'
export const ONBOARDING_SETTINGS = '/onboarding/settings'

// Admin edit/create routes
export const CREATE_COMPANY_INFORMATION = '/retailers/create'

// Pricing control routes
export const PRICING_INSURER_CATEGORIES = '/insurers/categories'
export const PRICING_INSURERS = '/insurers'
export const PRICING_INSURERS_PRICE_CREATE = `${PRICING_INSURERS}/:insurerId/category/:category/batch/:batchId/price/:duration`
export const PRICING_RETAILERS = '/pricing/retailers'
export const PRICING_RETAILER_BATCHES = `${PRICING_RETAILERS}/:retailerId/batches`
export const PRICING_RETAILER_PRICES = `${PRICING_RETAILERS}/:retailerId/batches/:batchId/prices/:duration`
export const PRICING_RETAILER_OVERRIDES = `${PRICING_RETAILERS}/:retailerId/overrides`
export const PRICING_RETAILER_OVERRIDES_EDIT = `${PRICING_RETAILERS}/:retailerId/overrides/edit/:overrideId`
export const PRICING_RETAILER_COVERAGE = `${PRICING_RETAILERS}/:retailerId/coverage`
export const PRICING_TAXONOMY = '/pricing/taxonomy'

// Claims routes
export const CLAIMS_CREATE = '/claims-new/create'
export const CLAIMS_CREATE_ID = '/claims-new/create/:uuid'
// removed // export const CLAIMS_ALL = '/claims/all'
export const CUSTOMER_FILE_A_CLAIM = '/file-a-claim/:claimId?/:claimType?'

// New Claims routes
export const CLAIMS_ALL_NEW = '/claims-new/all'
export const CLAIMS_ALL_NEW_DETAIL = '/claims-new/:claimId'

// Shipping Insurance routes
export const SHIPPING_INSURANCE_POLICY_DETAIL = '/shipping-insurance-policy/:id'

// Order Details routes
export const ORDER_WARRANTY_DETAIL = '/order/:orderId/warranty/:warrantyId'
export const ORDER_WARRANTY_CLAIMS_HISTORY =
  '/order/:orderId/claims-history/:warrantyId'

// Shield
export const SHIELD = '/shield'
export const SHIELD_CLIP_ID = '/shield/clips/:clipId'

// Admin
export const CLAIM_DOWNLOAD_ATTACHMENT_ID =
  '/warranty-claim-attachment/:attachmentId/download'

// Classification Auditor
export const CLASSIFIER = '/classifier'
export const CLASSIFIER_AUDIT_SESSION = '/classifier/:auditId'

export const USERS = '/users'
export const INVITATION_ACCEPT = '/invitations/:token'
export const ADMIN_REST = '/admin'

export const VAGRANT_ORDER_SEARCH = '/vagrant-orders'

export const ORDER_UPLOAD = '/order-upload'
export const ORDER_EDIT_UPLOAD = '/order-edit-upload'
export const ORDER_CREATE = '/order-create'

export const CARRIER_SUBMISSIONS = '/carrier-submissions'
export const ADMIN_ORDER_UPLOAD = '/admin-order-upload'
export const ADMIN_ORDER_EDIT_UPLOAD = '/admin-order-edit-upload'
